import * as sdk from "firebase/firestore";
import { isLocalPreview } from "./previewMode";
import { previewRef, previewConstraint, previewSnapshot, previewSubscribe, previewWrite, previewDelete, previewEmit } from "./previewStore";

export const Timestamp = sdk.Timestamp;
export const doc = (parent, ...parts) => isLocalPreview
  ? previewRef("doc", parent, parts.length ? parts : [crypto.randomUUID()]) : sdk.doc(parent, ...parts);
export const collection = (parent, ...parts) => isLocalPreview ? previewRef("collection", parent, parts) : sdk.collection(parent, ...parts);
export const query = (ref, ...constraints) => isLocalPreview ? { ...ref, constraints } : sdk.query(ref, ...constraints);
export const where = (...args) => isLocalPreview ? previewConstraint("where", ...args) : sdk.where(...args);
export const orderBy = (...args) => isLocalPreview ? previewConstraint("orderBy", ...args) : sdk.orderBy(...args);
export const limit = (...args) => isLocalPreview ? previewConstraint("limit", ...args) : sdk.limit(...args);
export const serverTimestamp = () => isLocalPreview ? sdk.Timestamp.now() : sdk.serverTimestamp();
export const deleteField = () => isLocalPreview ? { previewTransform: "delete" } : sdk.deleteField();
export const arrayUnion = (...values) => isLocalPreview ? { previewTransform: "union", values } : sdk.arrayUnion(...values);
export const arrayRemove = (...values) => isLocalPreview ? { previewTransform: "remove", values } : sdk.arrayRemove(...values);
export const getDoc = async ref => isLocalPreview ? previewSnapshot(ref) : sdk.getDoc(ref);
export const getDocs = async ref => isLocalPreview ? previewSnapshot(ref) : sdk.getDocs(ref);
export const onSnapshot = (ref, next, error) => isLocalPreview ? previewSubscribe(ref, next, error) : sdk.onSnapshot(ref, next, error);
export const setDoc = async (ref, data, options) => isLocalPreview ? previewWrite(ref, data, options?.merge) : sdk.setDoc(ref, data, options);
export const updateDoc = async (ref, data) => {
  if (!isLocalPreview) return sdk.updateDoc(ref, data);
  if (!previewSnapshot(ref).exists()) throw new Error("找不到預覽資料");
  previewWrite(ref, data, true);
};
export const deleteDoc = async ref => isLocalPreview ? previewDelete(ref) : sdk.deleteDoc(ref);
export const addDoc = async (ref, data) => {
  if (!isLocalPreview) return sdk.addDoc(ref, data);
  const target = doc(ref);
  await setDoc(target, data);
  return target;
};
export const writeBatch = db => {
  if (!isLocalPreview) return sdk.writeBatch(db);
  const operations = [];
  const paths = [];
  const batch = {
    set(ref, data, options) { paths.push(ref.path); operations.push(() => previewWrite(ref, data, options?.merge, false)); return batch; },
    update(ref, data) { paths.push(ref.path); operations.push(() => previewWrite(ref, data, true, false)); return batch; },
    delete(ref) { paths.push(ref.path); operations.push(() => previewDelete(ref, false)); return batch; },
    async commit() { operations.forEach(operation => operation()); previewEmit(paths); },
  };
  return batch;
};
